import { ReactNode } from 'react';

import { IPairWallet } from 'api/apiPairs/models';
import { IDexPair } from 'types/pairs';
import { TableAddressChip } from 'ui/Table/TableAddressChip/TableAddressChip';

interface SourceWalletSummaryProps {
  pair: IDexPair;
  sourceWallet: IPairWallet;
  balance?: ReactNode;
  footer?: ReactNode;
}

export const SourceWalletSummary = ({
  pair,
  sourceWallet,
  balance,
  footer,
}: SourceWalletSummaryProps) => {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm text-gray-300">From wallet</span>
      <div className="bg-[#141414] border border-[#2A2A2A] rounded px-3 h-10 flex items-center">
        <TableAddressChip
          address={sourceWallet.address}
          network={pair.network}
          className="text-gray-200"
        />
      </div>
      {(balance || footer) && (
        <div className="flex items-start justify-between gap-2 text-xs">
          {balance && <div className="text-gray-400 flex-1">{balance}</div>}
          {footer && <div className="text-right whitespace-nowrap">{footer}</div>}
        </div>
      )}
    </div>
  );
};
